var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    focusable: "false",
    width: "1em",
    height: "1em",
    style: {
      msTransform: "rotate(360deg)",
      WebkitTransform: "rotate(360deg)",
      transform: "rotate(360deg)"
    },
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 1250 1250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1023 473q0-4-1-8t-2.5-8t-3.5-7.5t-5-6.5l-1-1q-2-3-5-6l-6-6l-167-168V159q0-13-9.5-22.5T800 127H699L582 27q-11-11-24.5-17.5T529 1t-30 0t-28.5 8.5T446 27L330 127H224q-13 0-22.5 9.5T192 159v105L29 427Q0 446 0 481v479q0 27 19 45.5t45 18.5h896q17 0 32-8.5t23.5-23.5t8.5-32V478l-1-5zM269 726L64 916V545zm62 30q6-3 11-9q1-1 2-2.5t2-3.5l138-128q11-9 25-9t24 8l384 348H110zm427-26l202-179v361zm140-313h-1l55 55l-120 107V351zM491 72q10-9 23-9q6 0 12 2.5t11 6.5l64 55H427zm277 119v445l-57 51l-137-124q-6-5-13-9t-14-6.5t-14.5-4.5t-15.5-2.5t-15.5 0T486 543t-15 5t-14.5 7t-13.5 9L316 682l-60-53V191h512zM104 443l88-88v217L75 469l27-26h2z",
    fill: "#B3D6F0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1024,
    height: 1024,
    fill: "rgba(0, 0, 0, 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.d197a2a89e9c73d80f09e79d0a75b1f9.svg";
export { ForwardRef as ReactComponent };